import { InvoiceDetailsModel } from "model/InvoiceDetails.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = InvoiceDetailsModel | null;

export const useDefaultObservableInvoiceDetailsModelNull = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectInvoiceDetailsModelNull extends BehaviorSubject<CurrentType> {}
